import {
  afterRenderEffect,
  booleanAttribute,
  computed,
  createComponent,
  Directive,
  ElementRef,
  EnvironmentInjector,
  inject,
  input,
  Renderer2,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: `button[mat-button][loading],
             button[mat-raised-button][loading],
             button[mat-stroked-button][loading],
             button[mat-flat-button][loading],
             button[matButton][loading],
             button[mat-icon-button][loading],
             button[matIconButton][loading],
             a[mat-button][loading],
             a[mat-raised-button][loading],
             a[mat-stroked-button][loading],
             a[mat-flat-button][loading],
             a[matButton][loading],
             a[mat-icon-button][loading],
             a[matIconButton][loading]
             `,
  standalone: true,
  host: {
    '[attr.disabled]': 'isDisabled() || null',
  },
})
export class LoadingButtonDirective {
  loading = input.required({
    transform: booleanAttribute,
  });
  disabled = input(false, { transform: booleanAttribute });

  isDisabled = computed(() => this.loading() || this.disabled());

  constructor() {
    const elementRef = inject(ElementRef<HTMLButtonElement>);
    const injector = inject(EnvironmentInjector);
    const renderer = inject(Renderer2);
    const matIconButton = inject(MatIconButton, {
      optional: true,
    });

    afterRenderEffect({
      read: (onCleanup) => {
        if (!this.loading()) {
          return;
        }

        const spinnerRef = createComponent(MatProgressSpinner, {
          environmentInjector: injector,
        });
        spinnerRef.instance.diameter = matIconButton ? 24 : 16;
        spinnerRef.instance.mode = 'indeterminate';
        spinnerRef.changeDetectorRef.detectChanges();

        renderer.appendChild(
          elementRef.nativeElement,
          spinnerRef.location.nativeElement,
        );
        renderer.addClass(elementRef.nativeElement, 'lassi-loading');

        onCleanup(() => {
          renderer.removeClass(elementRef.nativeElement, 'lassi-loading');
          renderer.removeChild(
            elementRef.nativeElement,
            spinnerRef.location.nativeElement,
          );
          spinnerRef.destroy();
        });
      },
    });
  }
}
